import Button from '@mui/material/Button'
import DialogContent from '@mui/material/DialogContent'
import PropTypes from 'prop-types'
import React from 'react'

import HHBaseDialog from 'components/common/HHBaseDialog'
import HHDialogActions from 'components/common/HHDialogActions'
import HHDialogTitle from 'components/common/HHDialogTitle'
import T from 'T'

import UpcomingWorkOrders from './UpcomingWorkOrders'

const UpcomingWorkOrdersDialog = ({ isOpen = false, serviceType, workOrders = [], linkWorkOrders = false, onClose }) => {
  return (
    <HHBaseDialog maxWidth="lg" open={isOpen} onClose={onClose}>
      <HHDialogTitle title={T.SCHEDULE} onClose={onClose} />
      <DialogContent sx={{ p: 0 }}>
        <UpcomingWorkOrders linkWorkOrders={linkWorkOrders} serviceType={serviceType} sx={{ px: 3 }} workOrders={workOrders} />
      </DialogContent>
      <HHDialogActions>
        <Button size="small" variant="contained" onClick={onClose}>
          {T.CLOSE}
        </Button>
      </HHDialogActions>
    </HHBaseDialog>
  )
}

UpcomingWorkOrdersDialog.propTypes = {
  isOpen: PropTypes.bool,
  serviceType: PropTypes.string.isRequired,
  workOrders: PropTypes.array,
  linkWorkOrders: PropTypes.bool,
  onClose: PropTypes.func.isRequired,
}

export default UpcomingWorkOrdersDialog
